import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldPianoRoll } from '@/(routers)/boards/editor/block/definitions/fields/fieldPianoRoll';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.action.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
    blue: {
        rectColour: CATEGORIES.action.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

defineBlock({
    type: 'speaker',
    colour: CATEGORIES.action.color,
    tooltip: 'スピーカーから音を鳴らします',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/speaker.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('スピーカー', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: 'で' },
                {
                    type: 'field',
                    name: 'NOTES',
                    instance: () => new FieldPianoRoll([]),
                },
                { type: 'label', text: 'が鳴る ' },
            ],
        },
    ],
});
